import { Component, Input, OnDestroy } from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormGroup,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NgOtpInputConfig } from 'ng-otp-input';
import { Subject, takeUntil } from 'rxjs';
import { getCountDown } from 'server/shared/helpers/getCountDown';
import { LoginAuthProperties } from 'server/shared/helpers/types/AuthProperties';
import { AccountService } from '../../services/account.service';
import { ToastService } from '../../services/toast/toast.service';
@Component({
  selector: 'app-two-factor-authentication',
  templateUrl: './two-factor-authentication.component.html',
  styleUrls: ['./two-factor-authentication.component.scss'],
})
export class TwoFactorAuthenticationComponent implements OnDestroy {
  private destroyed$ = new Subject<void>();
  authForm = new FormGroup(
    {
      authCode: new FormControl(null, [this.customValidator()]),
    },
    { updateOn: 'change' },
  );
  resendLockInSeconds = 0;
  @Input() authData?: LoginAuthProperties;
  @Input() isPasswordReset?: boolean;

  config: NgOtpInputConfig = {
    allowNumbersOnly: true,
    length: 6,
    isPasswordInput: false,
    disableAutoFocus: false,
    placeholder: '',
  };

  constructor(
    private router: Router,
    private toastService: ToastService,
    public accountService: AccountService,
  ) {}

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  customValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }
      if (control.value.length === 6) {
        this.submit();
      } else {
        this.accountService.invalidAuthCode.next(false);
      }
      return null;
    };
  }

  submit(resendAuthCode?: boolean) {
    if (!this.authForm) return;
    if (resendAuthCode) {
      this.authForm.controls.authCode.setValue(null);
    }

    if (
      !resendAuthCode &&
      this.accountService.twoFactorAuthRequired &&
      this.authForm.controls.authCode.invalid
    )
      return;
    if (this.resendLockInSeconds === 0) {
    }
    if (!this.authData) return;

    this.accountService.loginMethod(
      {
        ...this.authData,
        twoFactorAuthCode: this.authForm.controls.authCode.value,
      },
      resendAuthCode,
      this.isPasswordReset,
    );
  }

  resendSMS() {
    if (this.resendLockInSeconds !== 0) return;
    this.submit(true);
    getCountDown(60)
      .pipe(takeUntil(this.destroyed$))
      .subscribe((res) => {
        this.resendLockInSeconds = res;
      });
  }

  goBack() {
    window.location.reload();
  }
}
